import {
  FETCH_FEATURED_PRODUCTS_REQUEST,
  FETCH_FEATURED_PRODUCTS_SUCCESS,
  FETCH_FEATURED_PRODUCTS_FAILURE
} from '../../actionTypes/featuredProductsActionTypes'

const fetchFeaturedProductsRequest = payload => {
  const action = {
    type: FETCH_FEATURED_PRODUCTS_REQUEST,
    payload
  }
  return action
}

const fetchFeaturedProductsSuccess = payload => {
  const action = {
    type: FETCH_FEATURED_PRODUCTS_SUCCESS,
    payload
  }
  return action
}

const fetchFeaturedProductsFailure = errorDetail => {
  const action = {
    type: FETCH_FEATURED_PRODUCTS_FAILURE,
    payload: errorDetail
  }
  return action
}

export { fetchFeaturedProductsRequest, fetchFeaturedProductsSuccess, fetchFeaturedProductsFailure }
